<template>
  <BaseIcon
    :width="width"
    :height="height"
    box="0 0 16 16"
  >
    <path
      v-show="checked"
      :fill="color"
      :stroke="borderColor"
      d="M.5 15.5V.5h15v15H.5Z"
    />
    <path
      v-show="!checked"
      fill="#fff"
      stroke="#474747"
      d="M.5 15.5V.5h15v15H.5Z"
    />
    <path
      fill="#fff"
      d="m11.98 5 1.02.93L7.45 12 4 8.12l1.03-.92 2.44 2.75L11.98 5Z"
    />
  </BaseIcon>
</template>

<script>
import BaseIcon from './BaseIcon.vue';

const tinycolor = require('tinycolor2');

export default {
  components: {
    BaseIcon,
  },
  props: {
    checked: {
      type: Boolean,
      required: true,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 16,
    },
    height: {
      type: [Number, String],
      default: 16,
    },
  },
  computed: {
    isDarkBg() {
      return tinycolor(this.color).isDark();
    },
    borderColor() {
      const tColor = tinycolor(this.color);
      return this.isDarkBg
        ? tColor.lighten(5).toString()
        : tColor.darken(5).toString();
    },
  },
};
</script>
